import { useCallback, useState } from 'react';

import getImageBySize from '@/common/helpers/getImageBySize';
import { PRODUCT_BARCODE_FORMAT } from '@/ebat/constants';

const usePicture = ({ src }) => {
  const [image, setImage] = useState(
    getImageBySize(src, PRODUCT_BARCODE_FORMAT),
  );
  const [hasError, setHasError] = useState(false);

  const onErrorImage = useCallback(() => {
    setImage(
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"></svg>',
    );
    setHasError(true);
  }, []);

  return {
    hasError,
    image,
    onErrorImage,
  };
};

export default usePicture;
